import { mCookie } from '@mshark/base';

// 获取did
function getDid (callback) {
    const didkey = `${window.$SYS.cookie_pre}did`;
    const cDid = mCookie.getItem(didkey);

    if (!cDid) {
        let auUrl = window.$SYS.authUrl || 'https://passport.douyu.com';

        auUrl = auUrl.replace(/\/$/, '');
        // 无斗鱼客户的did时，种入前端did
        $.ajax({
            url: `${auUrl}/lapi/did/api/get`,
            data: { client_id: 25 },
            type: 'get',
            dataType: 'jsonp',
            success: (res) => {
                if (res && +res.error === 0) {
                    const did = res.data && res.data.did;

                    mCookie.setItem(didkey, did);
                    if (callback && typeof callback === 'function') {
                        callback(did);
                    }
                }
            },
            error: () => {
                console.warn('did 请求失败');
            }
        });

        return;
    }

    if (callback && typeof callback === 'function') {
        callback(cDid);
    }
}

export default getDid;
